module.exports = __webpack_public_path__ + "2317a29ba0ec8fbef14851ea955e551a.MP3";